import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-gray-50 shadow ring-1 ring-gray-300", [$props.noPadding ? '' : 'p-4', $props.rounded ? 'rounded' : '']])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}